import { environment } from '../../../environments/environment';

export const isProduction = () => {
  return environment.production;
};

export const isUat = () => {
  return environment.sentry.environment == 'uat';
};

export const isStaging = () => {
  return environment.sentry.environment == 'staging';
};

export const isQuickQuoteFeatureEnabled = () => {
  return environment.quickQuoteEnabled;
};
